import { useIntl } from 'react-intl'
import { SubscriptionInfo } from 'features/home/types'

import {
  StyledHomeSubscriptionPlan,
  StyledHomeSubscriptionPlanIcon,
  PlanName,
} from './styles'
import SubscriptionIcon from 'components/Icons/SubscriptionIcon'
import { commonMessages } from 'app/i18n/messages'

interface DomainsHomeSubscriptionMultiPlanProps {
  subscriptionInfoArray: SubscriptionInfo[] | null
}

function DomainsHomeSubscriptionMultiPlan(
  props: DomainsHomeSubscriptionMultiPlanProps
) {
  const { subscriptionInfoArray } = props
  const { formatMessage } = useIntl()

  return (
    <>
      <StyledHomeSubscriptionPlan>
        {subscriptionInfoArray === null && (
          <StyledHomeSubscriptionPlanIcon>
            <SubscriptionIcon subscriptionInfo={null} />
          </StyledHomeSubscriptionPlanIcon>
        )}

        {subscriptionInfoArray !== null && (
          <>
            <StyledHomeSubscriptionPlanIcon>
              <SubscriptionIcon subscriptionInfo={subscriptionInfoArray[0]} />
            </StyledHomeSubscriptionPlanIcon>

            {subscriptionInfoArray.length === 1 && (
              <PlanName>
                {formatMessage(
                  subscriptionInfoArray[0].category === 'ESSENTIALS'
                    ? commonMessages.essentialPlan
                    : commonMessages.networkPlan
                )}
              </PlanName>
            )}

            {subscriptionInfoArray.length > 1 && (
              <>
                <StyledHomeSubscriptionPlanIcon>
                  <SubscriptionIcon
                    subscriptionInfo={subscriptionInfoArray[1]}
                  />
                </StyledHomeSubscriptionPlanIcon>
              </>
            )}
          </>
        )}
      </StyledHomeSubscriptionPlan>
    </>
  )
}

export default DomainsHomeSubscriptionMultiPlan
